/* ============================================================
   Cum Funcționează — mini-simulator orientativ de discount
   Model: cascadă pe 3 paliere (politica comercială)
   Final = Net × (1−Dvol) × (1−Dsort) × (1−Dfin)
   ESTIMARE — prețurile exacte apar după activare.

   ATENȚIE — acest simulator trebuie să rămână aliniat cu
   implementarea reală (Shopify Function `cascade-discount` +
   shop metafield b2b.cascade_config). Valorile sunt hardcodate
   aici intenționat (pagină publică, fără cont), dar REGULILE
   trebuie să fie identice:
     • Distribuitor NU are pas de volum — avantajul lui e deja
       în prețul de catalog (altfel s-ar dubla discountul).
     • Ramburs (+3%) se aplică TUTUROR segmentelor, inclusiv
       Distribuitor.
     • Ridicare din depozit (+2%) e un pas real, verificat la
       checkout după metoda de livrare aleasă.
     • Distribuitor are comandă minimă 4.000 RON net, care
       BLOCHEAZĂ finalizarea comenzii.

   Parametrii numerici (praguri, capuri, bonusuri) sunt citiți
   din data-* de pe `.kl-sim`, ca să fie editabili din schema
   secțiunii. Binding per-root + idempotent + re-run la
   `shopify:section:load` (theme editor / live reload).
   ============================================================ */
(function () {
  'use strict';

  function num(el, attr, fallback) {
    var v = parseFloat(el.getAttribute(attr));
    return isNaN(v) ? fallback : v;
  }

  function initSim(sim) {
    if (!sim || sim.dataset.cfBound === '1') return;
    sim.dataset.cfBound = '1';

    var cfg = {
      volCap: num(sim, 'data-vol-cap', 0.20),
      finPct: num(sim, 'data-fin-pct', 0.03),
      pickupPct: num(sim, 'data-pickup-pct', 0.02),
      distMin: num(sim, 'data-dist-min', 4000)
    };

    var state = {
      cart: num(sim, 'data-cart-default', 5000),
      cats: 3,
      fin: false,
      pickup: false,
      seg: 'standard'
    };

    /* ---- tabele după politica comercială ---- */
    function volume(seg, cart) {
      // Distribuitorul primește grila lui de preț direct în catalog, deci nu
      // mai are pas de volum aici — altfel discountul s-ar aplica de două ori.
      if (seg === 'distribuitor') return 0;
      if (cart < 1000) return 0;
      if (cart < 2000) return 0.10;
      if (cart < 4000) return 0.15;
      return cfg.volCap;                                   // [4000+] cap
    }
    function sortim(seg, cats) {
      if (seg === 'standard')     return cats >= 4 ? 0.05 : cats === 3 ? 0.03 : 0.02;
      if (seg === 'professional') return cats >= 4 ? 0.06 : cats === 3 ? 0.04 : 0.03;
      return cats >= 4 ? 0.08 : cats === 3 ? 0.06 : 0.05;  // distribuitor
    }
    // Bonusurile din pasul 3 se ADUNĂ între ele, apoi pasul intră cascadat.
    function financiar(fin, pickup) {
      var p = 0;
      if (fin) p += cfg.finPct;
      if (pickup) p += cfg.pickupPct;
      return p;
    }
    var MIN = { standard: 0, professional: 0, distribuitor: cfg.distMin };

    function fmtPct(x) { return (x * 100).toFixed(0); }
    function fmtPct1(x) { return (x * 100).toFixed(2).replace('.', ','); }
    function fmtRon(x) { return Math.round(x).toLocaleString('ro-RO'); }

    var q = function (sel) { return sim.querySelector(sel); };

    function recalc() {
      var dv = volume(state.seg, state.cart);
      var ds = sortim(state.seg, state.cats);
      var df = financiar(state.fin, state.pickup);
      var net = state.cart;
      var final = net * (1 - dv) * (1 - ds) * (1 - df);
      var equiv = 1 - final / net;
      var isDist = state.seg === 'distribuitor';

      q('[data-sim="pct"]').textContent = '−' + fmtPct1(equiv) + '%';
      q('[data-sim="vol"]').textContent = isDist ? 'în catalog' : '−' + fmtPct(dv) + '%';
      q('[data-sim="sort"]').textContent = '−' + fmtPct(ds) + '%';
      q('[data-sim="fin"]').textContent = df > 0 ? '−' + fmtPct(df) + '%' : '—';
      q('[data-sim="net"]').textContent = fmtRon(net) + ' RON';
      q('[data-sim="final"]').textContent = fmtRon(final) + ' RON';

      var volNote = q('[data-sim="vol-note"]');
      if (volNote) {
        volNote.textContent = isDist
          ? 'Prețul de catalog Distribuitor include deja avantajul de volum.'
          : '';
        volNote.hidden = !isDist;
      }

      var warn = q('[data-sim="warn"]');
      var minOrder = MIN[state.seg] || 0;
      if (minOrder > 0 && state.cart < minOrder) {
        warn.classList.add('show');
        q('[data-sim="warn-txt"]').textContent =
          'Pentru contul Distribuitor, comanda minimă este ' + fmtRon(minOrder) +
          ' RON net. Sub acest prag comanda nu poate fi finalizată.';
      } else {
        warn.classList.remove('show');
      }
    }

    /* ---- range: cart ---- */
    var range = q('[data-sim="cart"]');
    if (range) {
      range.value = state.cart;
      range.addEventListener('input', function () {
        state.cart = parseInt(range.value, 10);
        q('[data-sim="cart-val"]').textContent = fmtRon(state.cart) + ' RON';
        recalc();
      });
      q('[data-sim="cart-val"]').textContent = fmtRon(state.cart) + ' RON';
    }

    /* ---- segment toggle ---- */
    sim.querySelectorAll('.seg-toggle button').forEach(function (b) {
      b.addEventListener('click', function () {
        sim.querySelectorAll('.seg-toggle button').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        state.seg = b.dataset.seg;
        recalc();
      });
    });

    /* ---- categorii toggle ---- */
    sim.querySelectorAll('.cat-toggle button').forEach(function (b) {
      b.addEventListener('click', function () {
        sim.querySelectorAll('.cat-toggle button').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        state.cats = parseInt(b.dataset.cats, 10);
        recalc();
      });
    });

    /* ---- financiar / logistic ---- */
    var finCb = q('[data-sim="fin-input"]');
    if (finCb) finCb.addEventListener('change', function () { state.fin = finCb.checked; recalc(); });
    var pickupCb = q('[data-sim="pickup-input"]');
    if (pickupCb) pickupCb.addEventListener('change', function () { state.pickup = pickupCb.checked; recalc(); });

    recalc();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.kl-sim').forEach(initSim);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
